import {Component, OnDestroy, ViewChild} from '@angular/core';
import {Headers, Http, RequestOptions, RequestMethod} from '@angular/http';
import {Router, ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';
import 'rxjs/add/observable/interval';
import {EmitterService} from './modules/housekeeping/services/emitter.service'
import {Idle} from 'idlejs/dist';
import {GlobalVariable} from '../app/config';
import {GlobalDataService} from './modules/housekeeping/services/global-data.service';
let headers = new Headers({'Content-Type': 'application/json'});


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    //    title = 'app';
    public loadSpinner: boolean = false;
    public loadHeader: boolean = false;
    public ucode='';
    public user_type='';
    public apiendpoint_url = GlobalVariable.FORDAPIEndPointURL;
    constructor(private _dataService: GlobalDataService,public _router: Router, private http: Http, private _emitterService: EmitterService) {}

    ngOnInit() {
      const thisObj = this;
      const userObj = JSON.parse(localStorage.getItem("user"));
      if(userObj!=null && userObj.timezone!=null){
            this._dataService.getUserTimeZone();
        }
      const uuid = sessionStorage.getItem("uuid");
      const currentpath = window.location.pathname;
      this.checkTokenExist(); //Check the token exist or not for current login
        thisObj._emitterService.getSpinner().subscribe(value => {
            thisObj.loadSpinner = value;
        });
        thisObj._emitterService.getloadHeader().subscribe(value => {
            thisObj.loadHeader = value;
        });
        if (uuid != null && uuid != "failure") {
            if (currentpath == "/login" || currentpath == "/") {
                thisObj.loadHeader = true;
                this._router.navigate(['dashboard']);
            } else {
                thisObj.loadHeader = true;
                this._router.navigate([currentpath]);
            }
        } else {

            if (currentpath.includes('/resetPassword')) {
              const path = currentpath.split("/");
              this.ucode = path[2];
                this.user_type = path[3];
                if (this.ucode != '' && this.ucode != undefined && this.ucode != 'undefined') {
                    this._router.navigate(['/resetPassword/' + this.ucode + '/' + this.user_type]);
                } else {

                    this._router.navigate(['/forgotPassword']);
                }
            }else if(currentpath == "/preferences") {
             this._dataService.redirectUrl ="/preferences";
               this._router.navigate(['/login']);
            }
        }
        /**
        * @author  Pradeep
        * @uses  redirect to logout after 120 min of inactiveness
        */
        const idle = new Idle()
            .whenNotInteractive()
            .within(119)
            .do(() => thisObj._router.navigate(['logout']))
            .start();
    }
    checkTokenExist(){
      const thisObj = this;
      //var uuid = localStorage.getItem("uuid");
      const uuid = sessionStorage.getItem("uuid");
      const currentpath = window.location.pathname;
      //  console.log("**************"+uuid)
        if (uuid != null && uuid != "failure") {
            this.http.get(this.apiendpoint_url + '/user/tokenExists?userUUID='+uuid)
                .subscribe(
                    (data) => {
                        this._emitterService.setSpinner(false);
                      const res = data.json();//For Success Response
                       // console.log("********************"+res);
                        if (res == "TOKEN_EXISTS") {
                            if (currentpath == "/login" || currentpath == "/") {
                                thisObj.loadHeader = true;
                                this._router.navigate(['dashboard']);
                            } else {
                                thisObj.loadHeader = true;
                                this._router.navigate([currentpath]);
                            }
                        } else {
                            this._emitterService.setSpinner(false);
                            this._emitterService.setloadHeader(false);
                            //localStorage.clear();
                            sessionStorage.clear();
                            thisObj._router.navigate(['login']);
                        }
                    },
                    err => {
                        this._emitterService.setSpinner(false);
                        this._emitterService.setloadHeader(false);
                       // localStorage.clear();
                        sessionStorage.clear();
                        thisObj._router.navigate(['login']);
                    }
                );
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts